/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../../../../components/SearchableSelect/SearchableSelect'
import {Option} from '../../../../models/Sektor'
import {getKomercijalistePanelaDropdown} from '../../../../api/komercijalistePanelaDropdown'

//  Props for the component
interface DropdownProps {
    value?: string | number
    initialValue?: string | number
    onChange?: (name: string, value: any) => void
    errors?: string | undefined
    touched?: boolean
    selectName?: string
}

const KomercijalistePanelaDropdown: React.FC<DropdownProps> = ({
                                                                   value,
                                                                   initialValue,
                                                                   onChange,
                                                                   errors,
                                                                   touched,
                                                                   selectName,
                                                               }) => {
    const [komercijalistePanelaDropdown, setKomercijalistePanelaDropdown] = useState<Array<Option>>(
        []
    )
    const internalValue = initialValue ?? null

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getKomercijalistePanelaDropdown()
                console.log('res', response.data)
                setKomercijalistePanelaDropdown(mapData(response.data))
            } catch (error) {
                console.error('Error fetching dropdown data:', error)
            }
        }
        fetchData()
    }, [])

    const finalValue = value ?? internalValue

    const mapData = (data) => {
        if (!data) {
            return []
        }
        return data.map((item) => ({label: item.Naziv, value: item.Id?.toString()}))
    }

    return (
        <SearchableSelect
            options={komercijalistePanelaDropdown}
            value={finalValue?.toString() ?? ''}
            onChange={onChange!}
            name={selectName ?? 'komercijalistePanelaDropdown'}
            errors={errors}
            placeholder='Odaberi komercijalistu'
            touched={touched}
        />
    )
}

export default KomercijalistePanelaDropdown
